// Cross-subdomain auth sync. The actual login (password or Yandex) only
// happens on the main site; this middleware's job is purely to make an
// already-logged-in visitor recognized here too, via (in order of
// preference):
//   1. localStorage already set on this poddomain — nothing to do.
//   2. `authId`/`authToken` in the URL — we just landed back from
//      sharun.store/auth/check; stash them and strip the URL.
//   3. The shared `Id`/`Token` cookie (domain=.sharun.store / localhost) —
//      mirror it into localStorage so the rest of the app (api.js's
//      header-based auth) keeps working completely unchanged.
//   4. Nothing found — silently bounce through sharun.store/auth/check once
//      per tab as a last-resort fallback for browsers that won't send the
//      cross-subdomain cookie.
export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return

  if (localStorage.getItem('Id') && localStorage.getItem('Token')) return

  const authId = to.query.authId as string | undefined
  const authToken = to.query.authToken as string | undefined
  if (authId && authToken) {
    localStorage.setItem('Id', authId)
    localStorage.setItem('Token', authToken)
    syncCartAfterLogin()

    const query = { ...to.query }
    delete query.authId
    delete query.authToken
    return navigateTo({ path: to.path, query }, { replace: true })
  }

  const cookieId = readCookie('Id')
  const cookieToken = readCookie('Token')
  if (cookieId && cookieToken) {
    localStorage.setItem('Id', cookieId)
    localStorage.setItem('Token', cookieToken)
    syncCartAfterLogin()
    return
  }

  if (sessionStorage.getItem('authCheckDone')) return
  sessionStorage.setItem('authCheckDone', '1')

  const apiDomain = useRuntimeConfig().public.apiDomain as string
  const returnUrl = window.location.href
  return navigateTo(
    `${apiDomain}/auth/check?return=${encodeURIComponent(returnUrl)}`,
    { external: true }
  )
})

function readCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

function syncCartAfterLogin() {
  import('~/services/CartService').then(({ CartService }) =>
    CartService.getInstance().mergeLocalIntoServer()
  )
}
